import { Component, inject, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '@shared/services/shared.service';
import { IEntityTask } from 'app/models/entity-task/entity-task';
import { EntityTaskService } from 'app/services/entity-task/entity-task.service';

@Component({
  selector: 'app-entity-task',
  standalone: false,
  templateUrl: './entity-task.component.html',
  styleUrl: './entity-task.component.scss'
})

export class EntityTaskComponent implements OnInit {
  @Input() entityId: number = 0;
  @Input() entityType: string = '';

  public tasks: IEntityTask[] = [];

  public includeAll: boolean = false;

  public taskColumns: string [] = ['entityGuid', 'entityName', 'taskText', 'acknowledge', 'completed', 'dateCompleted'];
  public taskSource = new MatTableDataSource<IEntityTask>(this.tasks);

  @ViewChild('taskPaginator', { static: false })
  set taskPaginator(value: MatPaginator | undefined) {
    // Conditional views recreate these controls independently of data loading.
    this.taskSource.paginator = value ?? null;
  }
  get taskPaginator(): MatPaginator {
    return this.taskSource.paginator!;
  }
  @ViewChild('taskSort', { static: false })
  set taskSort(value: MatSort | undefined) {
    // Conditional views recreate these controls independently of data loading.
    this.taskSource.sort = value ?? null;
  }
  get taskSort(): MatSort {
    return this.taskSource.sort!;
  }

  private taskService: EntityTaskService = inject(EntityTaskService);
  public sharedService: SharedService = inject(SharedService);

  ngOnInit(): void {
    if(this.entityId === 0){
      this.getAllTasks();
    }
    else{
      this.getTasks();
      this.taskColumns = ['taskText', 'acknowledge', 'completed', 'dateCompleted'];
    }
  }

  getAllTasks(): void {
    this.taskService.getAllEntityTasks(this.entityType, this.includeAll).subscribe({
      next: response => this.tasks = response,
      error: error => console.error('error getting tasks', error),
      complete: () => this.updateTaskTable()
    });
  }

  getTasks(): void {
    this.taskService.getEntityTasks(this.entityId, this.entityType, this.includeAll).subscribe({
      next: response => this.tasks = response,
      error: error => console.error('error getting tasks', error),
      complete: () => this.updateTaskTable()
    });
  }

  updateTaskTable(): void {
    this.taskSource.data = this.tasks;
  }

  filterTasks(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.taskSource.filter = filterValue.trim().toLowerCase();
  }

  acknowledgeTask(task: IEntityTask): void {
    task.acknowledge = true;
    task.completed = true;
    this.taskService.updateEntityTask(task).subscribe({
      error: error => console.error('error acknowledging task', error),
      complete: () => {
        this.tasks = this.tasks.filter(t => t.id !== task.id);
        this.updateTaskTable();
        this.sharedService.toastr.success('Task acknowledged');
      }
    });
  }

}
